import '@/app/app.css';
import './cart.css';

import '@/app/app';
import '@/layouts/main/main.js';

import {ProductBlock} from '@/features/product-block/product-block';
import {SliderProducts} from '@/features/slider-products/slider-products';

window.app = window.app || {};

window.app.SliderProducts = SliderProducts;

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-sticky').forEach((element) => {
		new app.Sticky(element, {
			breakpoint: vars.breakpoint.desktop,
			indentTop: 0,
			indentBottom: 20,
			top: 80,
			bottom: 20,
		});
	});

	document.querySelectorAll('.product-block').forEach((element) => new ProductBlock(element));
	document.querySelectorAll('.js-slider-products').forEach((slider) => new SliderProducts(slider));
});
